import {React , useEffect , useState} from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Navbar from "../navbar/index";
import ContactUs from "../home/ContactUs";

const Layout = ({ children }) => {
  const [initialLoad, setInitialLoad] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        const headerOffset = 70; 
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;
  
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);
  
  
  
  const navLinks = [
    { name: "Home", to: "/" },
    {
      name: "Products",
      to: "/#products",
      categories: [
        {
          title: "Databases",
          items: [
            { name: "Private Equity - Venture Capital Database", to: "/products/pe" },
            { name: "Company Financials Search (CFS) Database", to: "/products/cfs" },
            { name: "Merger and Acquisitions Database", to: null },
            { name: "Private Equity-Real Estate Database", to: null },
          ]
        },
        {
          title: "Deal Digest Newsletter",
          items: [
            { name: "Premium Daily Edition", to: "/newsletters" },
            // { name: "Free Weekly Edition", to: "/weekly-newsletter" },
          ]
        },
        {
          title: "Other Products & Services",
          items: [
            { name: "Just Ask VI", to: "/products/justaskvi" },
            { name: "League Tables", to: "/leagues" },
            { name: "VC Landscape Report", to: "/india-venture-capital-landscape-report-2025" },
            { name: "AI & Deep Tech Report", to: "/india-ai-deeptech-investments-landscape-report-2026" },
            { name: "Series A Landscape Report", to: "/seriesareport" },
            { name: "Private Equity Impact Report", to: "/peimpact" },
            { name: "Products for Entrepreneurs", to: "/entrepreneurs" },
            { name: "VI News Digest", to: "https://news.ventureintelligence.com/" },
          ]
        },
        // {
        //   title : "MCA Downloader",
        //   items: [
        //     { name: "MCA Filings - Downloader Software", to: "/mcadownloader" },
        //   ]
        // },
        {
          title: "Directory",
          items: [
            { name: "The India Private Equity / Venture Capital Directory", to: "/pedirectory" },
            { name: "The India Private Equity-Real Estate Directory", to: "/peredirectory" },
            { name: "Directory of Early Stage Investors in India", to: "/pedirectory" },
            { name: "Limited Partners Directory", to: "/lpdirectory" },
          ]
        },
        {
          title: "Quick Links",
          items: [
            { name: "Indian Unicorn Tracker", to: "/Indian-Unicorn-Tracker" },
            { name: "Startup IPO Tracker", to: "/ipo-tracker" },
            { name: "Press Releases", to: "/Press-Release" },
            { name: "Events", to: "/Events" },
            { name: "VI Blog", to: "https://blog.ventureintelligence.com/" },
            { name: "Request Demo", to: "/trial.html" },
          ]
        }
      ],
    },
    { name: "League Tables", to: "/leagues" },
    { name: "What's New", to: "/#whats-new" },
    { name: "Our Customers", to: "/#Customers" },
    { name: "Careers", to: "/#careers" },
    { name: "Contact", to: "/#Contact" },
    { name: "Customer Login", to: "/dashboard" },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar navLinks={navLinks} />
      <main className="flex-grow">
        {children}
      </main>
      <ContactUs />
    </div>
  );
};

export default Layout;

